import MarkdownIt from "markdown-it";
import hljs from "highlight.js";
const md = new MarkdownIt({
	html: true,
	xhtmlOut: false,
	breaks: true,
	linkify: true,
	typographer: true,
	highlight: function (str, lang) {
		if (lang && hljs.getLanguage(lang)) {
			try {
				return '<pre class="hljs"><code>' + hljs.highlight(lang, str).value + "</code></pre>";
			} catch (__) {}
		}
		return '<pre class="hljs"><code>' + md.utils.escapeHtml(str) + "</code></pre>";
	}
});

export default md;
